import type { UpdateUserProfileBodyPreferences } from './updateUserProfileBodyPreferences';
import type { UpdateUserProfileBodySocialLinks } from './updateUserProfileBodySocialLinks';

export type UpdateUserProfileBody = {
  bio?: string;
  coverImageUrl?: string;
  fullName?: string;
  location?: string;
  preferences?: UpdateUserProfileBodyPreferences;
  profileImageUrl?: string;
  socialLinks?: UpdateUserProfileBodySocialLinks;
  website?: string;
};
